import { combineReducers } from 'redux';
import tableViewReducer from './tableView';
import addFieldReducer from './addField';
import picklistReducer from './picklist';
import restrictionReducer from './restriction';

const setupFields = combineReducers({
  tableView: tableViewReducer,
  addField: addFieldReducer,
  picklist: picklistReducer,
  restriction: restrictionReducer,
});
export default setupFields;



// WEBPACK FOOTER //
// ./src/views/Setup/Fields/flow/reducer/index.js